<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Setting Variable</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="4" class="fit-content">
                <v-text-field
                  label="Nama Perusahaan"
                  dense
                  hide-details
                  type="text"
                  v-model="formData.nama_perusahaan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="PPN (%)"
                  dense
                  hide-details
                  type="number"
                  step="0.01"
                  v-model="formData.ppn"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="PPh 23 (%)"
                  dense
                  hide-details
                  type="number"
                  step="0.01"
                  v-model="formData.pph23"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SettingVariable",
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        nama_perusahaan: "",
        ppn: "",
        pph23: ""
      }
    };
  },
  methods: {
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`variables`)
        .then(res => {
          const data = res.data;

          data.forEach(item => {
            if (item.key === "nama_perusahaan") {
              this.formData.nama_perusahaan = item.value;
            } else if (item.key === "ppn") {
              this.formData.ppn = item.value;
            } else if (item.key === "pph23") {
              this.formData.pph23 = item.value;
            }
          });

          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response?.data?.message || "Gagal mengambil data");
        });
    },
    async saveData() {
      this.loading.saveData = true;

      try {
        await axios.post(`variables`, {
          key: "nama_perusahaan",
          value: this.formData.nama_perusahaan
        });

        await axios.post(`variables`, {
          key: "ppn",
          value: this.formData.ppn
        });

        await axios.post(`variables`, {
          key: "pph23",
          value: this.formData.pph23
        });

        this.loading.saveData = false;
        alert("Data berhasil disimpan");
        this.fetchData();
      } catch (err) {
        this.loading.saveData = false;
        alert(err.response?.data?.message || "Gagal menyimpan data");
      }
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
